import ReactMarkdown from './ReactMarkdown';
export default ReactMarkdown;
